/*
 * Тихое продление сессии админпанели.
 *
 * ЗАЧЕМ. Access-токен user-сервиса живёт 24 часа, refresh — 30 дней. Раньше
 * админка refresh НЕ использовала вовсе: по истечении суток пользователя
 * молча выкидывало на /login — посреди работы, с риском потерять
 * заполненную форму. Теперь меняем протухающий access на свежий заранее.
 *
 * ОТКУДА БЕРЁТСЯ REFRESH. Сервер кладёт его в httpOnly-cookie `mc_refresh`
 * (path=/api-user, host-only). Админка ходит на свой origin через
 * `/api-user`, поэтому cookie возвращается сама — из JS её не прочитать и
 * не нужно. Для старых сессий, заведённых до появления cookie, отправляем
 * refreshToken из localStorage, если он там есть (его кладут OAuth-колбэки).
 *
 * 🔴 REFRESH ОДНОРАЗОВЫЙ: сервер его ротирует. Два параллельных запроса
 * (несколько вкладок или гонка таймера с перехватчиком) — второй получит
 * 401 и выкинет пользователя. Поэтому здесь ОДИН общий промис: все
 * одновременные вызовы ждут первый запрос, а не шлют свои.
 */
import axios from 'axios';
import { USER_addres } from './API';
import logger from '../utils/logger';

const REFRESH_URL = USER_addres + '/api/v1/users/auth/refresh';

// Идущий сейчас запрос продления (или null). Защита от гонки — см. выше.
let inFlight = null;

/** Сколько миллисекунд осталось жить токену. 0 — нет токена/не разобрали. */
export function tokenLeftMs() {
    const t = localStorage.getItem('Authorization');
    if (!t) return 0;
    try {
        const body = t.split('.')[1];
        if (!body) return 0;
        const json = JSON.parse(
            decodeURIComponent(escape(atob(body.replace(/-/g, '+').replace(/_/g, '/'))))
        );
        return typeof json.exp === 'number' ? json.exp * 1000 - Date.now() : 0;
    } catch (_) {
        return 0;
    }
}

/**
 * Обменять refresh на свежий access. Возвращает новый токен или null.
 * null — не повод паниковать: перехватчик 401 сам решит, разлогинивать ли.
 */
export function renewAccessToken() {
    if (inFlight) return inFlight;

    const stored = localStorage.getItem('refreshToken') || undefined;

    inFlight = axios
        .post(
            REFRESH_URL,
            stored ? { refreshToken: stored } : {},
            // withCredentials — чтобы ушла httpOnly-cookie mc_refresh.
            // Без него сервер не увидит refresh и ответит 400.
            { withCredentials: true }
        )
        .then((r) => {
            const token = r?.data?.token;
            if (!token) return null;
            localStorage.setItem('Authorization', token);
            // Новый refresh тоже приходит в теле (и в cookie). Кладём рядом,
            // чтобы старые сессии без cookie продолжали продлеваться.
            if (r.data.refreshToken) {
                localStorage.setItem('refreshToken', r.data.refreshToken);
            }
            logger.log('[renew] сессия продлена');
            return token;
        })
        .catch((e) => {
            const code = e?.response?.data?.code;
            // Устройство отключено («выйти везде», бан) — продлевать нечего.
            if (code === 'TOKEN_REVOKED') {
                logger.warn('[renew] сессия отозвана на сервере');
            } else {
                logger.warn('[renew] не удалось продлить:', e?.response?.status || e?.message);
            }
            return null;
        })
        .finally(() => {
            inFlight = null;
        });

    return inFlight;
}
